import {isIntervalInvalid, parseIntervalStringToObject, type IntervalString} from 'shared/ui-widgets/daterange-picker';
import type {DateRangeValueEditorValidations} from './types';
import type {Validator} from 'svelte-forms';
import type {Parser} from 'shared/value-editors/internal/forms/types';
import {exists, isDefined} from 'shared/utils/custom-utils';

export function dateRangeValidatorFactory(validations: DateRangeValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    validators.push(intervalStringValidator());

    return validators;
}

export function dateRangeParser(): Parser {
    return (value: string) => {
        if (!value) return null;
        return value as IntervalString;
    };
}

function intervalStringValidator(): Validator {
    return (value: IntervalString) => {
        try {
            const intervalObject = parseIntervalStringToObject(value);
            return {valid: !isIntervalInvalid(intervalObject), name: 'intervalInvalid'};
        } catch {
            return {valid: false, name: 'intervalInvalid'};
        }
    };
}

function requiredValidator(): Validator {
    return (value: IntervalString) => {
        try {
            const intervalObject = parseIntervalStringToObject(value);
            return {
                valid: exists(value) && !isIntervalInvalid(intervalObject) && value !== 'empty',
                name: 'intervalInvalid'
            };
        } catch {
            return {valid: false, name: 'intervalInvalid'};
        }
    };
}